<ion-header>
  <ion-toolbar>
    <ion-title>Información adicional</ion-title>
    <ion-buttons slot="end">
      <ion-button color="dark" (click)="closeModal()">
          <ion-icon name="close"></ion-icon>
        </ion-button>
  </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <mat-tab-group [selectedIndex]="tabGroupIndex" (selectedIndexChange)="setTabGroupIndex($event)" class="mat-tab-noclickable">
    <mat-tab label="Datos">
      <mat-checkbox (change)="useMyData($event)" >Utilizar mis datos</mat-checkbox>
      <app-form [questions]="insuranceQuestions1"></app-form>
      <div class="displayFlex">
        <button class="z-depth-2 smallButton" (click)="createInsuranceQuotation()">SIGUIENTE</button>
      </div>
    </mat-tab>
    <mat-tab label="Tipo vehículo">
      <app-form [questions]="insuranceQuestions2"></app-form>
      <div>
        <ion-grid>
          <ion-row padding class="clickable mobileNoHorizontalPadding">
            <ion-col size="6" size-md="6"  class=" flexEnd">
              <ion-label class="labels">Tipo de vehiculo:</ion-label>
            </ion-col>
            <ion-col size="6" size-md="6"  class="flexStart">
              <ion-label class="labels-info">{{insurance_quotation?.VehicleTypeName}}</ion-label>
            </ion-col>
          </ion-row>
          <ion-row padding class="clickable mobileNoHorizontalPadding">
            <ion-col size="6" size-md="6"  class="flexEnd">
              <ion-label class="labels">Marca:</ion-label>
            </ion-col>
            <ion-col size="6" size-md="6"  class="flexStart">
              <ion-label class="labels-info">{{insurance_quotation?.Brand}}</ion-label>
            </ion-col>
          </ion-row>
          <ion-row padding class="clickable mobileNoHorizontalPadding">
            <ion-col size="6" size-md="6"  class=" flexEnd">
              <ion-label class="labels">Linea:</ion-label>
            </ion-col>
            <ion-col size="6" size-md="6"  class="flexStart">
              <ion-label class="labels-info">{{insurance_quotation?.Line}}</ion-label>
            </ion-col>
          </ion-row>
          <ion-row padding class="clickable mobileNoHorizontalPadding">
            <ion-col size="6" size-md="6"  class=" flexEnd">
              <ion-label class="labels">Modelo:</ion-label>
            </ion-col>
            <ion-col size="6" size-md="6"  class="flexStart">
              <ion-label class="labels-info">{{insurance_quotation?.Model}}</ion-label>
            </ion-col>
          </ion-row>
          <ion-row padding class="clickable mobileNoHorizontalPadding">
            <ion-col size="6" size-md="6"  class=" flexEnd">
              <ion-label class="labels">Número de pasajeros:</ion-label>
            </ion-col>
            <ion-col size="6" size-md="6"  class="flexStart">
              <ion-label class="labels-info">{{insurance_quotation?.Passengers}}</ion-label>
            </ion-col>
          </ion-row>
          <ion-row padding class="clickable mobileNoHorizontalPadding">
            <ion-col size="6" size-md="6"  class=" flexEnd">
              <ion-label class="labels">Placa:</ion-label>
            </ion-col>
            <ion-col size="6" size-md="6"  class="flexStart">
              <ion-label class="labels-info">{{insurance_quotation?.Plate}}</ion-label>
            </ion-col>
          </ion-row>
          <ion-row padding class="clickable mobileNoHorizontalPadding">
            <ion-col size="6" size-md="6"  class=" flexEnd">
              <ion-label class="labels">Tipo de servicio:</ion-label>
            </ion-col>
            <ion-col size="6" size-md="6"  class="flexStart">
              <ion-label class="labels-info">{{insurance_quotation?.ServiceTypeName}}</ion-label>
            </ion-col>
          </ion-row>
          <ion-row padding class="clickable mobileNoHorizontalPadding">
            <ion-col size="6" size-md="6"  class=" flexEnd">
              <ion-label class="labels">Vigencia:</ion-label>
            </ion-col>
            <ion-col size="6" size-md="6"  class="flexStart">
              <ion-label class="labels-info">{{insurance_quotation?.StartDate}} a {{insurance_quotation?.EndDate}}</ion-label>
            </ion-col>
          </ion-row>
          <ion-row padding class="clickable mobileNoHorizontalPadding">
            <ion-col size="6" size-md="6"  class=" flexEnd">
              <ion-label class="labels">Ciudad:</ion-label>
            </ion-col>
            <ion-col size="6" size-md="6"  class="flexStart">
              <ion-label class="labels-info">{{insurance_quotation?.CityName}}</ion-label>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>     
      <div class="displayFlex">
        <button class="z-depth-2 smallButton" (click)="updateInsuranceQuotation()">SIGUIENTE</button>
      </div>
    </mat-tab>
    <mat-tab label="Finalizar">
      <div class="verticalCenter horizontalCenter bigPriceContainer">
        <ion-icon color="primary" *ngIf="configService.company_info?.currency_icon_svg" [src]="configService.company_info?.currency_icon_svg"></ion-icon>
        <span *ngIf="product.discount || product.discount == 0" class="priceText">
          {{product.price - product.discount | currency:'COP':''}} 
          <span *ngIf="!configService.company_info?.currency_icon_svg">&nbsp;{{configService.company_info.points_name}}</span>
        </span>
      </div>
      <div class="displayFlex">
        <button class="z-depth-2 smallButton" (click)="addToShoppingCart()">AGREGAR AL CARRITO</button>
      </div>
    </mat-tab>
  </mat-tab-group>
 <!-- FORM -->
<!--  <div class="formContainer reverseFlex">
  <h4>¿Quién usará este Bono?</h4>
  <mat-checkbox (change)="useMyData($event)" >Utilizar mis datos</mat-checkbox>
  <app-form [questions]="couponQuestions1" (submit)="addToShoppingCart()"></app-form>
  <h4  *ngIf="couponQuestions2">¿Dónde se usará este Bono?</h4>
  <app-form *ngIf="couponQuestions2" [questions]="couponQuestions2" (submit)="addToShoppingCart()"></app-form>
  <button *ngIf="!is_busqo_quotation" class="z-depth-2 smallButton" (click)="addToShoppingCart()">AGREGAR</button>
</div> -->
</ion-content>